import React, { useEffect, useState } from "react";
import SwInspectionReports from "../components/SwInspectionReports";
import { useDispatch } from "react-redux";
import * as clientAction from "../../../../redux/actions/clientAction";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useSelector } from "react-redux";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  PAGE_SIZE,
} from "../../../../constant/constant";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import { useLocation } from "react-router-dom";
import Loader from "../../../../library/common/Loader";

function SwInspectionReportsContainer() {
  const location = useLocation();
  const dashboardReportPath = location.state.dashboardReportPath;

  const orgId = localStorage.getItem("orgId");
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.allUsers);
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const isSearchClientLoading = allClients.isLoading;

  const getSwInspectionList = useSelector((state) => state.getSwInspectionList);

  const getSwInspectionListData = (data) => {
    dispatch(swInspectionAction.getSwInspectionList(data));
  };

  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };

  const refData = {
    flags: [3, 4],
  };

  useEffect(() => {
    getSwReferenceData(refData);
  }, []);
  const defaultData = {
    search: "",
    inspectionTypeId: 0,
    frequencyId: "",
    projectId: 0,
    customerId: LOGIN_ORG_ID() === parseInt(HBNEXT_ORG_ID) ? 1 : orgId,
    statusId: 6, //tabid
    startDate: "",
    endDate: "",
    page: 1,
    pageSize: PAGE_SIZE,
    userId: "",
    inspectionSubmitType: "",
    statusIds: 5,
  };

  useEffect(() => {
    getSwInspectionListData(defaultData);
  }, []);
  const autoSearchDataLoading =
    allUsers?.isLoading || getSwInspectionList?.isLoading;
  return (
    <>
      {autoSearchDataLoading && (
        <>
          <Loader />
        </>
      )}
      <SwInspectionReports
        autoSearchDataLoading={autoSearchDataLoading}
        allClients={allClients}
        searchClient={searchClient}
        allUsers={allUsers?.data?.users}
        getSwInspectionList={getSwInspectionList?.data}
        getSwInspectionListData={getSwInspectionListData}
        isSearchClientLoading={isSearchClientLoading}
        inspectionTypeValue={getSwReference?.data}
        dashboardReportPath={dashboardReportPath}
      />
    </>
  );
}

export default SwInspectionReportsContainer;
